import Modal    from "react-bootstrap/Modal";
import { Table } from "react-bootstrap";
import { Button } from "../../common/Button";
import CustomPagination from "../../common/components/Pagination/CustomPagination";
import moment   from "moment";
import { useState } from "react";

export default function StatusHistoryModal({ history = [], show, onHide }) {
  const rows = [...history]
    .map((e, i, a) => ({
      ts  : e?.period?.start ?? null,
      who : e?.actor?.display ?? "-",
      old : i === 0 ? "-" : a[i - 1].status,
      new : e.status,
    }))
    .reverse();

  const [page, setPage] = useState(0);
  const rowsPerPage     = 3;
  const pagedRows       = rows.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  return (
    <Modal
      centered backdrop="static"
      className="custom-dialog"
      show={show} onHide={onHide} size="lg"
    >
      <Modal.Header closeButton className="border-0">
        <Modal.Title>Status History</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="table-wrap">
          <Table responsive >
            <thead>
              <tr>
                <th>Timestamp</th>
                <th>Updated&nbsp;By</th>
                <th>Old</th>
                <th style={{ textAlign: "center", width: 25 }}>→</th>
                <th>New</th>
              </tr>
            </thead>

            <tbody>
              {pagedRows.length ? (
                pagedRows.map((r, i) => (
                  <tr key={i}>
                    <td>
                      {r.ts ? moment(r.ts).format("DD-MMM-YY HH:mm") : "—"}
                    </td>
                    <td style={{ textTransform: "capitalize" }}>{r.who}</td>
                    <td>{r.old}</td>
                    <td style={{ textAlign: "center" }}>→</td>
                    <td>{r.new}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={5} className="text-center">
                    No history
                  </td>
                </tr>
              )}
            </tbody>
          </Table>

          {rows.length > 0 && (
            <CustomPagination
              tableData={rows}
              totalRows={rows.length}
              rowsPerPage={rowsPerPage}
              page={page}
              handlePage={setPage}
            />
          )}
        </div>

        <div className="btn-wrap center-btns">
          <Button onClick={onHide} variant="secondary" title="Cancel" >Close</Button>
        </div>
      </Modal.Body>
    </Modal>
  );
}
